import { useQueryClient, QueryClient, QueryClientProvider } from 'react-query';

export { getEventsById } from './api';
export { useInfiniteEvents, useEventsById, useEvents } from './hooks';
export {
    transformDiscoveryEvent,
    transformDestinationEvent,
} from './transforms';
export { DiscoveryEvent, FormattedEvent, DestinationEvent } from './types';
export { DEFAULT_DESTINATION_EXPANSIONS } from './constants';
export { EventCard, CONSUMER_CARD_DEFAULTS } from './components/EventCard';

// In case the implementation changes down the line,
// export wrappers around the clients.
const EventClient = QueryClient;
const EventClientProvider = QueryClientProvider;
const useEventClient = useQueryClient;

export { EventClient, EventClientProvider, useEventClient };
